const legal = {
  infoPageLayout: {
    manageCookies: "Gestionar mis cookies",
  },
  terms: {
    title: "Condiciones de uso",
    subtitle: "Normas generales aplicables al acceso y uso de Qubiq.",
    sections: [
      {
        title: "1. Objeto",
        body: "{{brandName}} es una plataforma interactiva de streaming de vídeo que permite ver contenidos, interactuar con juegos integrados y utilizar funciones comunitarias.",
      },
      {
        title: "2. Acceso al servicio",
        body: "El acceso a determinadas funciones de Qubiq requiere la creación de una cuenta. El usuario se compromete a proporcionar información exacta, mantener la confidencialidad de sus accesos y no desviar el servicio de su uso normal.",
      },
      {
        title: "3. Contenidos y comportamientos prohibidos",
        body: "Está prohibido publicar, difundir o retransmitir contenidos ilícitos, fraudulentos, de odio, violentos, engañosos, pornográficos no autorizados, que vulneren derechos de terceros o contrarios a las reglas de moderación de Qubiq.",
      },
      {
        title: "4. Propiedad intelectual",
        body: "Los elementos de la plataforma Qubiq, su diseño, sus marcas, sus elementos visuales, sus interfaces y sus desarrollos están protegidos. Salvo autorización expresa, no pueden copiarse, reproducirse, extraerse ni reutilizarse con fines comerciales.",
      },
      {
        title: "5. Suspensión o eliminación de cuenta",
        body: "Qubiq puede restringir, suspender o eliminar el acceso a todo o parte del servicio en caso de incumplimiento de estas condiciones, intento de fraude, comportamiento perjudicial para la comunidad o riesgo de seguridad.",
      },
      {
        title: "6. Contacto",
        body: "Si tienes alguna pregunta sobre estas condiciones, puedes escribir a {{contactEmail}}.",
      },
    ],
  },
  privacy: {
    title: "Política de privacidad",
    subtitle: "Cómo trata Qubiq los datos personales y cómo ejercer tus derechos.",
    sections: [
      {
        title: "Responsable del tratamiento",
        body: "{{companyName}}, accesible a través de {{websiteUrl}}, actúa como responsable del tratamiento de los datos tratados en el marco de la plataforma {{brandName}}.",
      },
      {
        title: "Datos tratados",
        body: "Según tu uso del servicio, podemos tratar: identidad de la cuenta, correo electrónico, nombre de usuario, imagen de perfil, historial de uso, interacciones comunitarias, preferencias de consentimiento, información técnica de navegación y datos relacionados con el wallet o las ganancias cuando se utilizan estas funciones.",
      },
      {
        title: "Finalidades y bases legales",
        body: "- Proporcionar el servicio, la reproducción de vídeo, los juegos, el perfil y las notificaciones: ejecución del servicio.\n- Proteger la plataforma, luchar contra el fraude y moderar contenidos: interés legítimo y obligaciones legales.\n- Gestionar solicitudes de soporte y derechos RGPD: obligación legal e interés legítimo.\n- Medir la audiencia con Google Analytics: consentimiento.",
      },
      {
        title: "Destinatarios",
        body: "Los datos son accesibles, según la necesidad, para los equipos autorizados de Qubiq y sus proveedores técnicos. Qubiq utiliza en particular Clerk para la autenticación y Google Analytics para la medición de audiencia cuando lo aceptas.",
      },
      {
        title: "Plazos de conservación",
        body: "Los plazos varían según la finalidad:\n- cuenta de usuario: durante la existencia de la cuenta y después según las obligaciones legales aplicables;\n- registros técnicos y de seguridad: el tiempo limitado necesario para la seguridad y el diagnóstico;\n- preferencias de cookies: 6 meses;\n- datos de audiencia: según la configuración de Google Analytics y la política de conservación elegida por Qubiq.",
      },
      {
        title: "Transferencias fuera de la UE",
        body: "Algunos proveedores pueden tratar datos fuera de la Unión Europea. En ese caso, Qubiq aplica las garantías adecuadas exigidas por el RGPD, incluidas cláusulas contractuales apropiadas cuando sean necesarias.",
      },
      {
        title: "Tus derechos",
        body: "Dispones, según el caso, de los derechos de acceso, rectificación, supresión, oposición, limitación, portabilidad y del derecho a retirar tu consentimiento en cualquier momento para los tratamientos basados en él. También puedes presentar una reclamación ante la CNIL.",
      },
      {
        title: "Contacto de datos personales",
        body: "Para cualquier solicitud relacionada con tus datos personales: {{privacyEmail}}.",
      },
    ],
  },
  legalNotice: {
    title: "Aviso legal",
    subtitle: "Información sobre el editor del servicio y el alojamiento del sitio.",
    items: {
      editorLabel: "Editor del sitio",
      legalFormLabel: "Forma jurídica",
      legalFormValue: "{{legalForm}} — capital social: {{capital}}",
      registrationLabel: "Registro",
      registrationValue: "Registro Mercantil de {{registrationCity}} {{registrationNumber}}",
      registrationDateLabel: "Fecha de registro",
      euidLabel: "EUID",
      vatLabel: "Número de IVA intracomunitario",
      addressLabel: "Dirección",
      activitiesLabel: "Actividades principales",
      publicationDirectorLabel: "Director de la publicación",
      contactLabel: "Contacto",
      hostingLabel: "Alojamiento",
      hostingValue: "{{hostingCompany}}\n{{hostingAddress}}",
      intellectualPropertyLabel: "Propiedad intelectual",
      intellectualPropertyValue:
        "Los contenidos, interfaces, marcas, elementos visuales y desarrollos del servicio Qubiq están protegidos. Queda prohibida toda reproducción o explotación no autorizada.",
    },
  },
  cookies: {
    title: "Política de cookies",
    subtitle: "Información sobre los rastreadores utilizados por Qubiq y la gestión de tus elecciones.",
    sections: [
      {
        title: "Principio",
        body: "Qubiq utiliza cookies y otros rastreadores necesarios para el funcionamiento del servicio. Los rastreadores de medición de audiencia están desactivados por defecto y solo se activan tras tu consentimiento explícito.",
      },
      {
        title: "Categorías utilizadas",
        body: "- Cookies necesarias: seguridad, inicio de sesión, estabilidad de sesión, funcionamiento esencial.\n- Medición de audiencia: Google Analytics 4, con consentimiento.\n- Marketing: por ahora no está activado en Qubiq.",
      },
      {
        title: "Duraciones y terceros",
        body: "- Preferencia de consentimiento de Qubiq: almacenada localmente bajo la clave {{consentStorageKey}} durante 6 meses.\n- {{analyticsProvider}}: cookies de medición de audiencia, duración por defecto anunciada por Google: hasta 2 años, sujeta a las limitaciones del navegador y a la configuración elegida por Qubiq.\n- Tercero implicado en la medición de audiencia: Google.",
      },
      {
        title: "Google Analytics",
        body: "{{analyticsProvider}} no se carga antes de tu consentimiento. Cuando lo aceptas, Qubiq utiliza la medición de audiencia para comprender mejor el uso del servicio, mejorar el rendimiento e identificar las grandes tendencias de navegación.",
      },
      {
        title: "Retirar o modificar el consentimiento",
        body: "Puedes cambiar tus elecciones en cualquier momento desde el botón “Gestionar mis cookies” disponible en esta página, en los enlaces informativos del sitio y en el menú de perfil.",
      },
      {
        title: "Recordatorio normativo",
        body: "En Qubiq, rechazar las cookies de medición de audiencia es tan fácil como aceptarlas. El servicio principal sigue siendo accesible sin activar Google Analytics.",
      },
    ],
  },
  moderation: {
    title: "Reglas de moderación de Qubiq",
    subtitle: "Las reglas de la Qubiq Republic para proteger a la comunidad, a los creadores y a los jugadores.",
    sections: [
      {
        title: "1. Respeto a la comunidad",
        body: "No se permiten insultos, ataques dirigidos, humillaciones, amenazas, campañas de acoso ni comportamientos destinados a perjudicar a otro usuario, creador o moderador.",
      },
      {
        title: "2. Contenidos ilegales o peligrosos",
        body: "Se prohíben: la apología de crímenes, el terrorismo, el contenido pedocriminal, el doxxing, la difusión no autorizada de datos personales, las estafas, el fraude, el hackeo, la incitación al odio o cualquier publicación contraria a la ley.",
      },
      {
        title: "3. Engaño, spam y manipulación",
        body: "Está prohibido hacer spam, manipular artificialmente la audiencia, publicar concursos falsos o engañar a los usuarios sobre recompensas, juegos, qubs o condiciones de participación.",
      },
      {
        title: "4. Protección de menores",
        body: "Se prohíben los contenidos sexualizados, impactantes, humillantes o peligrosos para menores. Los usuarios deben evitar cualquier puesta en escena inapropiada o explotación de públicos vulnerables.",
      },
      {
        title: "5. Juegos y fair play",
        body: "Cualquier intento de hacer trampas, automatización abusiva, eludir reglas de run, duplicar recompensas, explotar bugs o alterar deliberadamente la experiencia de juego puede dar lugar a la suspensión o eliminación de la cuenta.",
      },
      {
        title: "6. Derechos de terceros",
        body: "Debes disponer de los derechos necesarios para publicar contenido en Qubiq. Las infracciones de derechos de autor, imagen, privacidad o marcas de terceros pueden dar lugar a una moderación inmediata.",
      },
      {
        title: "7. Medidas posibles",
        body: "Qubiq puede eliminar un contenido, limitar ciertas funciones, bloquear un uso compartido, suspender una cuenta, retirar ventajas vinculadas a la plataforma o comunicar los hechos a las autoridades cuando la situación lo justifique.",
      },
      {
        title: "8. Espíritu Qubiq",
        body: "Qubiq es una plataforma interactiva: se puede debatir, jugar, rendir y compartir. Pero la experiencia debe seguir siendo sana, justa, clara y respetuosa. Si un contenido rompe ese equilibrio, puede ser moderado.",
      },
    ],
  },
};

export default legal;
